// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"779":"3f45e773","6282":"f3971fa0"}[chunkId] + ".chunk.css";
};